// extracted by mini-css-extract-plugin
export default {"tokens":"\"../../styles/tokens.css\"","blue":"#007DFF","red":"#FF2F2F","link":"styles_link__2krNO","strong":"styles_strong__iOlez","warning":"styles_warning__yg5Kh"};